<div class="sp-dialog__max-width-m sp-dialog__min-width">
	<div class="sp-width__full sp-row__end">
		<button
			(click)="onCloseClick()"
			mat-icon-button
			class="sp-icon__button sp-icon__button-accent">
			<mat-icon> clear </mat-icon>
		</button>
	</div>

	<div class="sp-padding__x2">
		<h3 class="sp-color__accent">{{ 'ERROR.TITLE' | translate }}!</h3>
		<p class="sp-margin__top-x2">{{ message || '' | translate }}</p>
	</div>
</div>
